var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.path.includes('rule') && _vm.$route.path !== '/' && _vm.$route.path !== '/home')?_c('NavBar'):_vm._e(),_c('router-view',{staticClass:"middle-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }